<template>
  <div class="success-return-page row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-lg-8 mx-auto">
          <div class="bg-white shadow-sm p-5">
            <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
              <progress-check-icon style="font-size:110px;" class="text-color-1" />
              
              <div class="ml-3">
                <p>Seus dados foram registrados!</p>

                <p>Isso significa que a sua inscrição para o processo seletivo do <strong>Programa Trainee do Grupo Boticário 2025</strong> está confirmada e você está mais próximo de fazer parte do futuro da beleza.</p>

                <p>A partir de agora, você receberá mensagens na plataforma da 99jobs e notificações por e-mail com mais detalhes sobre esse processo seletivo. Lembre-se de sempre checar a área logada da <a href="https://99jobs.com" target="_blank">99jobs.com</a>, sua caixa de entrada no e-mail ou até mesmo o lixo eletrônico para garantir que não deixou passar nenhuma comunicação nossa.</p>

                <p>Caso tenha alguma dúvida ou dificuldade, pode entrar em contato conosco através do e-mail traineegrupoboticario@99jobs.com</p> 

                <p><strong>Ah, antes de ir, queremos te pedir um minutinho de atenção - é rápido assim!</strong></p> 
                <p>Por aqui, buscamos SEMPRE melhorar o nosso processo de seleção dos melhores talentos do Brasil, por isso, contamos com você para responder a essa breve pesquisa de satisfação para que nos conte suas impressões sobre a etapa de inscrições. Para acessá-la, <a href="https://99jobsfacaoquevoceama.typeform.com/to/HlhXY5Dc?typeform-source=www.google.com" target="_blank">clique aqui.</a></p>

                <p>Ou acesse o link: <a href="https://99jobsfacaoquevoceama.typeform.com/to/HlhXY5Dc" target="_blank">https://99jobsfacaoquevoceama.typeform.com/to/HlhXY5Dc</a></p>

                <p>Obrigada e boa sorte!<br />99jobs 💙 Grupo Boticário</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoaderContent from '@/components/loader/LoaderContent.vue'
  import Hero from '@/components/media/Hero.vue'
  import ProgressCheckIcon from "vue-material-design-icons/ProgressCheck.vue"
  import AlertCircleIcon from "vue-material-design-icons/AlertCircle.vue";
  import FileAlertIcon from "vue-material-design-icons/FileAlert.vue";
  import FileCheckIcon from "vue-material-design-icons/FileCheck.vue";
  import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
  import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";
  import scriptMixin from '@/scriptMixin.js';

  export default {
    name: 'SubscriptionSuccessReturn',

    data() {
      return {
        isLoading: false,
        tests: [],
        opportunity: null,
      }
    },

    computed: {
      opportunityId(){
        const id = this.$route.query.id.match(/\d+/)[0]
        return id
      },

      username() {
        return this.$store.state.user.profile.name.split(' ')[0]
      }
    },

    components: {
      LoaderContent,
      Hero,
      ProgressCheckIcon,
      AlertCircleIcon,
      FileAlertIcon,
      FileCheckIcon,
      FileDocumentOutlineIcon,
      FileCheckOutlineIcon,
      ChevronRightIcon
    },

    beforeDestroy() {
      document.getElementById("someExtraContent").innerHTML = '';
    },

    mixins: [scriptMixin],

    async mounted() {
      this.loadTrackingScripts();
      this.addInlineScript(`
        gtag('event', 'conversion', {
          'send_to': 'AW-383921375/oeVrCIzotNgZEN_ZiLcB',
          'value': 1.0,
          'currency': 'BRL'
        });
      `, 'google-conversion-page');

      this.addInlineScript(`
       !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1120372455132381');
        fbq('track', 'Inscricao_treinee');
      `, 'Inscricao_treinee-conversion-page');

      this.addInlineScript(`
       window.lintrk('track', { conversion_id: 19982801 });
      `, 'lintrk-conversion-page');
      
      this.isLoading = true;
      await this.getOpportunity();

      this.$store.dispatch('tests/subscriptionTests', {
        opportunityId: this.opportunityId,
        finishedTests: false,
        requiredIn: 'thank_you'
      }).then(tests => {
        this.tests = tests.subscriptionTests.json || []
        this.tests = this.tests.filter(test => test.hide_to_candidate == false);
        this.isLoading = false
      });
    },

    methods: {
      async getOpportunity(){
        let counter = 0;

        const get = () => {
          this.$store.dispatch("opportunities/getOpportunity", this.$route.query.id).then((opportunity) => {
            if (opportunity) {
              this.opportunity = opportunity;
              this.notFound = false;
              this.pageTitle = this.$helpers.toTitle(this.opportunity.title);
              this.$emit("updateHead");
            }  else {
              this.notFound = true;
            }
          });
        };

        get();
      },

      goToTest(testId){
        window.afterTestBackTo = this.$route.fullPath;
        this.$router.push(`vagas/${this.opportunity.id}/inscricao/${ testId }`);
      },

      alertAssessfirst(link) {
        this.$swal({
          title: "Atenção",
          text: "Você será direcionado para o site Assessfirst para realizar o teste.",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          confirmButtonText: "Vamos lá!",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.open(link, '_blank');
          }
        });
      },

      alertEtalent(link) {
        this.$swal({
          title: "Atenção",
          text: "Você será direcionado para o site E-talent para realizar o teste.",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          confirmButtonText: "Vamos lá!",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.open(link, '_blank');
          }
        });
      },
    },

  }
</script>

<style lang="scss" scoped>
  .success-return-page {
    height: 100%;
    margin-top: 5%;
  }
</style>
